import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-gray-300">
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* 회사 정보 */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">동두천 글로벌인재육성센터</h3>
            <div className="space-y-2 text-sm">
              <p>(주)한원글로벌 동두천지점</p>
              <p>대표자: 김한경</p>
              <p className="leading-relaxed">
                주소: 경기도 동두천시 동두천로 97, 2층<br />
                (지행동, 동두천싸이언스타워)
              </p>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">빠른 링크</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  센터소개
                </Link>
              </li>
              <li>
                <Link to="/courses" className="hover:text-white transition-colors">
                  교육과정
                </Link>
              </li>
              <li>
                <Link to="/notice" className="hover:text-white transition-colors">
                  공지사항
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* 고객지원 */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">고객지원</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/community/faq" className="hover:text-white transition-colors">
                  자주묻는 질문
                </Link>
              </li>
              <li>
                <Link to="/application/register" className="hover:text-white transition-colors">
                  수강신청
                </Link>
              </li>
              <li>
                <Link to="/mypage" className="hover:text-white transition-colors">
                  마이페이지
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Dongducheon Global Talent Center. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
